import CardDetail from 'component/cardDogList/CardDetail'

export default function Detail () {
  return <CardDetail />
}
